import { assertMatchesObjectShape, isRuntimeTypeOf } from '@augment-vir/common';
export function objectToSearchParamsString(inputObject) {
    const searchParams = new URLSearchParams(Object.entries(inputObject));
    const searchParamsString = searchParams.toString();
    if (searchParamsString) {
        return `?${searchParamsString}`;
    }
    else {
        return '';
    }
}
export function searchParamStringToObject(inputUrl, verifyShape) {
    const urlForSearchParams = isRuntimeTypeOf(inputUrl, 'string') ? new URL(inputUrl) : inputUrl;
    const searchEntries = Array.from(urlForSearchParams.searchParams.entries());
    const paramsObject = Object.fromEntries(searchEntries);
    if (verifyShape) {
        assertMatchesObjectShape(paramsObject, verifyShape);
    }
    return paramsObject;
}
